import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Center, Spinner, VStack, Text } from '@chakra-ui/react'
import { useAuth } from '../contexts/AuthContext'

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, isValidating } = useAuth()
  const location = useLocation()

  // Show loading spinner while validating token
  if (isValidating) {
    return (
      <Center h="100vh" bg="#09090b">
        <VStack spacing={4}>
          <Spinner
            size="xl"
            color="#f97316"
            thickness="4px"
          />
          <Text color="gray.400">Loading...</Text>
        </VStack>
      </Center>
    )
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Render protected content
  return children
}
